import { useEffect, useState } from 'react';
import { Button, Modal, Input, message } from 'antd';
import './index.less';

const AddCompony = (props: any) => {
  const { handleOK, handleCancel, addTitle, setInputComName, comName, setComName } = props;
  console.log('props', props);

  const [inputNameStatus, setInputNameStatus] = useState('');
  useEffect(() => {
    return () => {
      setComName('');
    };
  }, []);

  // 输入框的内容
  const [okStatus, setOkStatus] = useState(false);
  const onInputChange = (e: any) => {
    if (e.target) {
      // getAddComponyInfo(e.target.value);
      if (e.target.value === '') {
        setOkStatus(false);
        setInputNameStatus('error');
      } else {
        console.log('****公司名称', e.target.value);
        setInputComName(e.target.value);
        setOkStatus(true);
        setInputNameStatus('');
      }
      if (e.target.value.length === 100) {
        message.warning('公司名称最多输入100个字符');
      }
    }
  };

  return (
    <>
      <Modal
        title={addTitle}
        visible={true}
        onOk={handleOK}
        onCancel={handleCancel}
        footer={
          okStatus
            ? [
                <Button onClick={handleCancel}>取消</Button>,
                <Button type="primary" onClick={() => handleOK()}>
                  确定
                </Button>,
              ]
            : [
                <Button onClick={handleCancel}>取消</Button>,
                <Button type="primary" onClick={() => handleOK()} disabled>
                  确定
                </Button>,
              ]
        }
      >
        <div className="modalContent" style={{ margin: 0 }}>
          <div style={{ paddingTop: '10px' }}> 公司名称 </div>
          <div className="modalInput" style={{ paddingTop: '8px' }}>
            <Input
              placeholder="输入公司名称"
              onChange={onInputChange}
              status={inputNameStatus === 'error' ? inputNameStatus : undefined}
              defaultValue={comName}
              maxLength={100}
            />
            {inputNameStatus === 'error' ? (
              <div className="inputMention" style={{ top: 40 }}>
                请输入公司名称
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};
export default AddCompony;
